import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { MsalGuard } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

/**
 * Local dev bypass: no Azure AD account exists in local-noauth builds, so MsalGuard's
 * interactive login redirect would otherwise fire on every visit to a guarded route.
 */
export const msalOrBypassGuard: CanActivateFn = (route, state) => {
  if (environment.authBypass) return true;
  return inject(MsalGuard).canActivate(route, state);
};
